import DoNotDecryptRule from '../../entities/DoNotDecryptRule'; 

export default class SubmitDoNotDecryptRequestRule {

	action!: string;

	operation!: string;

	sourceIPs!: string;

	destinationIPs!: string;

	destinationPorts!: string;

	description!: string;

	protocol!: string;

	service!: string;

	region!: string;

	trafficDirection!: string;

	ruleName: string;

	constructor(rule: DoNotDecryptRule) { 
		Object.assign(this, rule);
		this.action = "Allow";
		this.operation = rule.operation?.name;
		this.region = rule.region?.name;
		this.trafficDirection = rule.trafficDirection?.name;
		this.ruleName = rule.name;
	}
}